import type {
	SRT_Column,
	SRT_Row,
	SRT_RowData,
	SRT_TableInstance,
} from '../types'

import { useCallback, useMemo } from 'react'

import { useVirt } from '../virt/useVirt'
import { useSRT_Rows } from './useSRT_Rows'

/* eslint-disable react-hooks/rules-of-hooks */
export function useGridVirtualizer<T extends SRT_RowData>(
	table: SRT_TableInstance<T>,
	{
		getRowHeight,
		getColSize,
	}: {
		getRowHeight: (row?: SRT_Row<T>) => number
		getColSize:
			| ((column: SRT_Column<T>) => number)
			| ((column?: SRT_Column<T>) => undefined)
	}
) {
	const {
		options: { enableVirtualization },
		refs: { tableContainerRef },
	} = table

	if (!enableVirtualization) {
		return undefined
	}

	const rows = useSRT_Rows(table)
	const visibleColumns = useMemo(
		() => [
			...table.getLeftVisibleLeafColumns(),
			...table.getCenterVisibleLeafColumns(),
			...table.getRightVisibleLeafColumns(),
		],
		[table.getAllColumns()]
	) //table.getVisibleLeafColumns()
	const getScrollElement = useCallback(
		() => tableContainerRef.current!,
		[tableContainerRef]
	)

	const virt = useVirt<T>({
		enabled: enableVirtualization,
		rows,
		columns: visibleColumns,
		getScrollElement,
		getRowHeight,
		getColSize,
	})

	return virt.getGrid()
}
